module.exports = __webpack_public_path__ + "img/981314c.svg";